<template>
  <div class="activate-banner">
    <div class="activate-banner-inner">
      <div class="content">
        <p class="h-heading-h2">
          {{ $t('components.activate_banner.text1') }} <span>{{ $t('components.activate_banner.text2') }}</span>
        </p>
        <div class="button-wrap">
          <h-btn :large="$vuetify.breakpoint.smAndDown" :x-large="$vuetify.breakpoint.mdAndUp" inverted block color="secondary" class="cta" @click="activationAction">{{ $t('components.activate_banner.cta') }}</h-btn>
        </div>
      </div>
      <img v-if="$vuetify.breakpoint.smAndDown" class="pdf" :src="require(`@/assets/activate-pdf-voucher-${currentLocale}.png`)" :alt="$t('components.activate_banner.pdf')" />
      <img v-else class="pdf-large" :src="require(`@/assets/activate-pdf-voucher-${currentLocale}2.png`)" :alt="$t('components.activate_banner.pdf')" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'activate-banner',
  computed: {
    ...mapGetters('ui', ['currentLocale']),
  },
  methods: {
    ...mapActions('overlay', ['openHeaderDrawerWithParams']),
    activationAction() {
      this.$emit('activationAction');
    },
  },
};
</script>

<style lang="scss" scoped>
.activate-banner {
  background-color: white;
  padding: var(--gap-large);
  @media ($md-min) {
    padding-bottom: 0;
  }
}

.activate-banner-inner {
  background-image: url('~@/assets/activate-gradient.png');
  display: flex;
  justify-content: space-between;
  background-size: cover;
  background-position: 0 100%;
  @media ($md-min) {
    background-size: auto;
    background-position: 0 70%;
    height: 186px;
    overflow: hidden;
  }
}

.content {
  min-width: 66%;
  padding: 24px;
  @media ($md-min) {
    order: 2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 36px;
    padding-right: 26px;
  }
}

.pdf {
  min-width: 34%;
  object-fit: cover;
  object-position: 0 0;
  @media ($md-min) {
    padding-left: 16px;
  }
}

.pdf-large {
  width: 34%;
  object-fit: cover;
  padding-left: 36px;
  margin-bottom: -50px;
}

p {
  color: var(--color-background-alt);
  padding-bottom: 12px;
  @media ($md-min) {
    max-width: 422px;
    padding-bottom: 0;
    margin-bottom: 0 !important;
    font-size: 1.5rem; // Could remove, but makes it look nicer
  }
  @media (min-width: 1130px) {
    font-size: 2rem; // Could remove, but makes it look nicer
  }
  span {
    @media (min-width: 481px) {
      display: block;
    }
  }
}

.button-wrap {
  @media ($sm-min) {
    order: 2;
  }
  @media ($md-min) {
    width: auto;
    margin: 10px;
  }
}

.cta {
  @media ($md-min) {
    min-width: 0 !important;
  }
}
</style>
